
import { reactive, onMounted, computed, watch, ref } from 'vue';
import Checkbox from '../checkbox/index.vue';
import CTmenu from '../ctmenu/index.vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

export default {
  name: 'tablebox',
  components: {
    Checkbox,
    CTmenu
  },
  props: {
    defaultCheck: { // 原始外面丟進來的打勾
      type: Array,
      required: false,
      default: [],
    },
    hasContextmenu: { // 右鍵
      type: Boolean,
      required: false,
      default: false,
    },
    dotInfo: { // 全域點點點
      type: Boolean,
      required: false,
      default: true,
    },
    disableCheck: {  //check box disable 
      type: Array,
      required: false,
    },
    tableScrollHeight: {  //可以上下滑
      type: [String],
      required: false,
    },
    tablePadding: {  //每一格的 padding，用來調整一下寬度不然會破
      type: [String, Number],
      required: false,
      default: '24',
    },
    checkBox: {
      type: Boolean,
      required: false,
      default: false,
    },
    // checkBox: {
    //   type: Array,
    //   required: false,
    //   default: undefined,
    // },
    dropdown: {
      type: [String, Boolean],  //是否可以有下拉選單，填寫String的話可以mapping row data 是否有這個值，沒有的話就不顯示
      required: false,
      default: false,
    },
    columns: {
      type: Array,
      required: false,
      default: [

        {
          title: "Name", // render在頁面上的欄位名稱
          key: "name", // 對應data矩陣的key值
          align: 'alignLeft',//alignLeft : text-align:left -->自定義CSS屬性，去css檔案裡面找
        },
        {
          title: "Download availability",
          customRender: "box", //客製化slot，可用於外接其他組件
          key: "box",
          width: "20%",  //指定寬度
        },
        {
          title: "Address",
          key: "address",
          color: true,  // 是否有客製化顏色，有的話直接讀取data值作為class名稱
          colorEnum: {   //把enum指定進來，table會自動讀取 col.colorEnum[row[col.key]] 
            0: 'online',
            1: 'offline',
            2: 'waiting',
          },
          // isI18n:  //多國語系而且又要變色的話
          //   {
          //     0: t('__g3p_m8t.__offline'),
          //     1: t('__g3p_m8t.__online'),
          //     2: t('__g3p_m8t.__waiting'),
          //   },
          sort: true, //此欄位是否有排序功能
        },
        {
          title: "color range",
          key: "range",
          color: true,
          colorRange:  //比大小的概念來上色，這邊都把key 設定為這段range最小值
          {
            0: 'general',  //0以上 一個顏色
            74: 'caution',  //75以上 一個顏色
            79: 'limit',  //79 以上 一個顏色
          },
          sort: true, //此欄位是否有排序功能
        },
        {
          title: "date",
          key: "date",
          sort: true,
          align: 'left', //align 的位置
        },
        {
          title: "link",
          key: "link",
          isLink: true, //有連結可以去其他頁面或POPUP
          linkRestrict: 'linkFlag', //有沒有辦法進連結的限制，後面是限制連結的條件key值，

        },
        {
          title: "textLimit",
          key: "textLimit",
          textLimit: true, // 刪節符號與hover出現完整資訊的效果，需搭配指定寬度使用
          width: "15%",
        },
        {
          title: "group",
          key: "group",
          clickPopUp: 'group_info', //可以點擊出現選單，參數請設定需要被綁進Popup的key值
          clickPopUpIcon: 'asus_proart_sw_ico_arrow_s3', //此為default
        },
        {
          title: "Download availability",
          customRender: "button",
          key: "button",
        }
      ],
    },
    data: {
      type: Array,
      required: false,
      default: [
        {
          id: 1111,
          name: "CC",
          address: 0,
          link: 'toPageAaa',
          linkFlag: true,
          date: '2020/03/21',
          group: 'group name1',
          group_info: ['111', '1111'],
          range: 20,
          dataInfo: [
            {
              id: 342,
              brightness: "male",
              colorTemperature: "54",
              gamma: "0934532289"
            },

          ]
        },
        {
          id: 222,
          name: "RR",
          address: 0,
          link: 'tttt',
          linkFlag: false,
          date: '2022/01/04',
          group: 'group name2',
          group_info: ['22', '5555'],
          range: 77,
          textLimit: 'gkregnir',
          dataInfo: [
            {
              id: 342,
              brightness: "male",
              colorTemperature: "54",
              gamma: "0934532289"
            },

          ]
        },
        {
          id: 33,
          name: "EE",
          address: 1,
          link: 'toPageBbb',
          linkFlag: true,
          textLimit: '但是 vue3 除了 watch api， 还新增了一个 watchEffect 的 api， 我们来看看他的用法。',
          date: '1945/11/30',
          range: 100,
        },
        {
          id: 4,
          name: "SS",
          address: 2,
          textLimit: '我们收集了一个 userID 的依赖，然后在 userID 改变的时候，就会执行watchEffect 的回调。',
          date: '1956/09/40',
          range: 66,
        },

        {
          id: 5,
          name: "654htr",
          address: 5494,
          textLimit: '我们收集了一个 userID 的依赖，然后在 userID 改变的时候，就会执行watchEffect 的回调。',
          date: '1956/09/40',
          range: 9,
        },
      ],
    },

  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const root = ref(null);
    let target = null;
    let x = 0;
    let y = 0;

    const store = useStore()
    const storeState = store.state;

    // console.log('root', root)




    const dataInit = () => {
      if (props.disableCheck) { //擋掉check box 預設disable
        state.disableList = props.disableCheck
      } else {
        state.disableList = new Array(state.dataList.length).fill(false)
      }


      for (let i = 0; i < state.dataList.length; i++) {
        state.dataList[i].tableId = i
      }
      // console.log(state.dataList.length,'table data')
      // console.log(state.dataList,"datalist")
      state.dataCheck = new Array(state.dataList.length).fill(false)
      if (props.defaultCheck.length) {
        props.defaultCheck.forEach((e) => {
          for (let i = 0; i < state.dataCheck.length; i++) {
            if (e == i) {
              // if(!state.disableList[i]){ //如果預設有勾但同時牴觸disables
              state.dataCheck[i] = true;
              state.checkDataList.push(state.dataList[i]);
              // }

            }
          }
        });
      }

      state.taleExtend = new Array(state.dataList.length).fill(false)


    }


    onMounted(() => {
      dataInit()
      state.sorting = new Array(state.dataList.length).fill(true) //不要放進init裡面，不然每次資料回來都會被default
      target = root.value;
      x = target.getBoundingClientRect().x;
      y = target.getBoundingClientRect().y;
      textLimitHoverPopup()

      window.addEventListener("resize", (() => {
        textLimitHoverPopup()
      }));
    })




    const textLimitHoverPopup = () => {
      target = root.value;
      setTimeout(() => {
        if (!target) return
        let a = target.querySelectorAll('.normalTd')
        for (let i = 0; i < a.length; i++) {
          if (a[i].scrollHeight > a[i].clientHeight) {
            a[i].classList.add('hasPopUp')
          } else {
            a[i].classList.remove('hasPopUp')
          }
        }
      }, 1)
    }

    const { data } = props;
    const state = reactive({
      allCheck: false, //原始全選 v-model
      dataCheck: [],  //有被選擇與否，全data Array，true or false
      taleExtend: [], //打開與否，全data Array，true or false
      checkDataList: [], //被選擇的詳細data list
      columns: 0,
      selected: null,
      sorting: [],
      mouseOver: '',
      clickContent: [],
      clickIndex: null,
      position: {
        x: null,
        y: null,
      },
      dataList: data,
      isCheckAll: false, //手動點擊全部打勾的checkbox
      disableList: [], //checkbox disable list
      hoverCol: '',
      hoverRow: '',
    })


    watch(
      () => props.data,
      (val) => {
        state.checkDataList = [];
        state.dataList = val;
        state.allCheck = false
        if (val.length > 0) {
          dataInit()
          textLimitHoverPopup()
        }
      },
      { deep: true }
    )
    watch(
      () => state.checkDataList,
      (val) => {
        // console.log(state.checkDataList,"state.checkDataList")
        if (val.length == state.dataList.length) {
          emit('onCheckAll', state.checkDataList)
        } else {
          emit('onCheckEach', state.checkDataList)
        }
      },
      { deep: true }
    )

    watch(
      () => state.allCheck,
      (val) => {
        // console.log("state.allcheck")
        let arr = state.dataList.map((e) => { return e })
        // console.log(state.disableList)
        if (state.isCheckAll) {
          if (props.disableCheck) {
            let temp = state.dataList.map((e, index) => { return props.disableCheck[index] ? null : e })
            if (state.allCheck) {
              state.checkDataList = temp.filter(e => e !== null)
            } else {
              state.checkDataList = []
            }

            if (props.defaultCheck.length) {
              props.defaultCheck.forEach((e) => { //預設勾選
                for (let i = 0; i < state.dataCheck.length; i++) { //each checkbox全部打勾
                  if (!state.dataCheck[e]) {  //是預設勾選
                    if (val) {
                      state.dataCheck[i] = !state.disableList[i];
                    }
                  } else {
                    if (!state.disableList[i]) {
                      if (val) {
                        state.dataCheck[i] = !state.disableList[i];
                      } else {
                        state.dataCheck[i] = false
                      }
                    }
                  }
                }
              })
            } else {
              for (let i = 0; i < state.dataCheck.length; i++) {
                if (val) {
                  state.dataCheck[i] = !state.disableList[i];
                } else {
                  state.dataCheck[i] = false
                }
              }

            }


          }
          else {
            state.checkDataList = val ? arr : []
            for (let i = 0; i < state.dataCheck.length; i++) { //each checkbox全部打勾
              state.dataCheck[i] = val;
            }
          }
        }

        // emit('onCheckAll', state.checkDataList)  //手動全部打勾才會送出 onCheckAll
      },
    )

    watch(
      () => state.dataCheck,
      (val) => {
        let check = 0
        if (val.length) {
          if (props.disableCheck) { //如果有預設disable checkbox
            for (let i = 0; i < val.length; i++) {
              if (val[i]) {
                check += 1
              }
            }
            let org = props.disableCheck.length - props.disableCheck.filter(Boolean).length //原本該勾的，設定全選的數量，EX: 5個checkbox，3個 disable，全選就是勾兩個
            let disableAndDefault = 0 //又 disable 又 default 的特例
            props.defaultCheck.forEach((e) => {
              if (props.disableCheck[e]) {
                disableAndDefault += 1;
              }
            })

            let allCheck = org + disableAndDefault; //
            state.allCheck = check == allCheck && check > 0 ? true : false
          } else {
            for (let i = 0; i < val.length; i++) {
              if (val[i]) {
                check += 1
              }
            }
            state.allCheck = check == val.length && check > 0 ? true : false   //個別勾選全勾與否
          }

        }
        // state.isCheckAll = check ==  val.length ? true : false
      },
      { deep: true }
    )



    const beforeChange = (v) => {
      if (v == 'all') {
        state.isCheckAll = true; //手動全部打勾
        
      } else {
        state.isCheckAll = false;
      }

    }


    const checkOnChange = (v) => {   //個別勾選
      if (state.dataCheck[v]) {
        state.checkDataList.push(state.dataList[v])
      } else {
        for (let i = 0; i < state.checkDataList.length; i++) {
          if (state.checkDataList[i].tableId == state.dataList[v].tableId) {
            state.checkDataList.splice(i, 1)
          }
        }
      }
      // emit('onCheckEach', state.checkDataList)
    }


    const showContextMenu = (e, row, rowIndex) => {
      // console.log(props)
      if (!props.hasContextmenu) return
      if (props.disableCheck) {
        if (props.disableCheck[rowIndex]) {
          e.preventDefault()
          return
        }
      }

      e.stopPropagation();
      e.preventDefault();
      state.position.x = e.pageX - x;
      state.position.y = e.pageY - y;

      let list = []
      if (state.checkDataList.length) {
        if (state.dataCheck[rowIndex]) { //再有被勾到的資料列上點右鍵

        } else {
          for (let i = 0; i < state.dataCheck.length; i++) {
            state.dataCheck[i] = false
          }
          state.dataCheck[rowIndex] = true
          state.checkDataList = []
          state.checkDataList.push(row)
        }
      } else {
        state.dataCheck[rowIndex] = true
        state.checkDataList.push(row)
      }
      list = state.checkDataList
      emit('showCTAndRow', { e, row, rowIndex, list })

    }

    const style = computed(
      () => {
        return {
          paddingLeft: `${props.tablePadding}px`,
          paddingRight: `${props.tablePadding}px`
        }
      }
    )


    const tdSort = (i, e) => {

      if (e.sort) {
        state.sorting[i] = !state.sorting[i]
        let result = state.sorting[i] ? 'up' : 'down';
        emit('tableSort', { key: e.key, val: result, index: i })
        if (state.selected == i) {
          state.selected = null;
        } else {
          state.selected = i;
        }
      }

    }



    const emptyTr = computed(() => {
      let empty = 0
      if (props.checkBox || props.dropdown) {
        empty = 1
      }
      if (props.checkBox && props.dropdown) {
        empty = 2
      }
      return empty
    }
    )


    const extend = (i) => {
      state.taleExtend[i] = !state.taleExtend[i]
    }

    // table detail style  :class="[row[col.key] > col.colorRange]"
    const styleInit = (col, val, rowIndex) => {
      let className = [];
      if (col.color) {
        if (col.colorRange) {
          let colorClass = ''
          for (let obj in col.colorRange) {
            if (val > parseInt(obj)) {
              colorClass = col.colorRange[obj]
            }
          }
          className.push(colorClass)
        } else { //colorEnum
          // console.log(col, val,col.colorEnum[val])
          className.push(col.colorEnum[val])
          // className.push(CONNECTION[val])
          // if (col.title == t('__d7d_n17r.__connectionStatus')) {
          //   className.push(CONNECTION[val])
          // }

        }
      }
      if (col.isLink) {
        if (col.linkRestrict) {
          if (state.dataList[rowIndex][col.linkRestrict]) {
            className.push('isDecoration')
          }
          // console.log('hi',col.linkRestrict)
          // console.log('state.dataList[rowIndex]',)

        } else {
          className.push('isDecoration')
        }

      }
      if (col.textLimit) {
        if(!storeState.mobileDevice){
          className.push('textLimit')
        }
      }
      if (col.align) {
        className.push(col.align)//alignLeft : text-align:left -->自定義
      }

      if(!storeState.mobileDevice){
        className.push('textLimit')
      }else{
        className.push('testAlignLeft')
      }


      return className
    }

    const tdStyle = (col, val) => {
      let className = [];
      if (col.clickPopUp) {
        if (val) {
          className.push('clickPopUpDefault')
        }

      }
      return className
    }

    const goLink = (col, val, rowIndex) => {

      if (col.isLink) {
        if (col.linkRestrict) {
          if (state.dataList[rowIndex][col.linkRestrict]) {
            emit('goTableLink', { val, col })
          }
        } else {
          emit('goTableLink', { val, col })
        }

      }

    }

    const hoverEffect = (e, col, val, ri, ci) => {
      // console.log('aaaa')
      if (e.target.children.length) {
        if (!e.target.children[0].classList.contains('hasPopUp')) return
      } else {
        return
      }
      if (props.dotInfo || col.textLimit) {
        state.hoverRow = ri;
        state.hoverCol = ci;
        state.mouseOver = val;
      }

    }

    const clickPopUpEffect = (col, i, row) => {
      if (col.clickPopUp) {
        if(state.clickIndex !=null){
          state.clickIndex = null
        }else{
          state.clickIndex = i;
          state.clickContent = row[col.clickPopUp];
        }
      }
    }

    const handleFocusOut = () => {
      state.clickContent = []
      state.clickIndex = null;
    }


    return {
      state,
      dataInit,
      tdSort,
      extend,
      emptyTr,
      checkOnChange,
      styleInit,
      goLink,
      hoverEffect,
      showContextMenu,
      root,
      style,
      clickPopUpEffect,
      handleFocusOut,
      tdStyle,
      beforeChange,
      textLimitHoverPopup,
      t,
      // selectContextMenu
    }
  }// end: setup
}


